;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View = APP.module('View');

	View.LeaguesManageControls = Marionette.ItemView.extend({
		template: null,
		ui: {
			league_select   : '.js-league-select',
			share_btn       : '.js-share',
			countdown       : '.js-countdown',
			canvas          : '.circle_animation'
		},
		events: {
			'change @ui.league_select'  : 'changeLeague',
			'click @ui.share_btn'       : 'shareInvite'
		},
		initialize: function() {
			this.league_id = this.getOption('league_id');
			this.share     = this.getOption('share');
			this.leagues   = this.getOption('leagues');
			this.ladder    = this.getOption('ladder');
			this.league    = this.getOption('league');
			this.user      = this.getOption('user');

			if ( this.getOption('myClass') ) {
				$(this.el).addClass(this.getOption('myClass'));
			}

			// var data = {id: this.league_id};
			//
			// var complete = [
			// 	this.leagues.show_my().fetch(),
			// 	// this.ladder.league_ladder().fetch({data: data})
			// ];

			this.leagues.show_my().fetch().done(_.bind(this.initTemplate, this));
			this.setTemplate();
		},

		initListeners: function(){
			return this;
		},

		setTemplate: function(){

			this.template = this.getOption('template') ? this.getOption('template') : JST.TippingLeaguesManageControls;

			this.setDefaultModel();

			return this;
		},

		setDefaultModel: function() {
			this.model.set({
				league:  {},
				leagues: [],
				user_rank : ''
			});
		},

		initTemplate: function() {
			this.showPreloader();
			return this.startInitData().done(_.bind(this.finishInitData,this))

		},

		startInitData: function() {

			this.leagues.setCommissioner(this.user.get('id'));

			console.log(this.leagues);

			this.league = this.leagues.findWhere({ id: +this.league_id });

			return this.league.show_by_id(this.league_id);

		},

		finishInitData: function(model){

			if (this.isDestroyed) return this;

			// this.league = model;

			return 	this.setModelData()
				.render()
				.initCountdown();

		},

		setModelData: function() {

			this.model.set({
				league:  this.league.toJSON(),
				leagues: this.leagues.toJSON(),
				user_rank : this.ladder.get('user_rank')
			});

			this.hidePreloader();
			return this;
		},
		changeLeague: function() {
			var route = Backbone.history.getFragment().replace(this.league_id, ':league_id');

			this.league_id = this.ui.league_select.val();
			//this.league    = this.leagues.findWhere({ id: +this.league_id });

			Backbone.history.navigate(route.replace(':league_id', this.league_id), {trigger:true});

			APP.vent.trigger('leagues_manage_controls:change_league', this.league_id);

			return this.initTemplate();

			//return this.setModelData().render().initCountdown();
		},
		shareInvite: function(e) {
			var $el    = $(e.currentTarget),
				league = this.leagues.findWhere({ id: +$el.data('id') });

			this.share.invite({
				type:      $el.data('type'),
				team:      this.user.get('team_name'),
				team_id:   league.get('team_id'),
				league:    league.get('name'),
				league_id: $el.data('id'),
				user_id:   this.user.get('id'),
				code:      league.get('code')
			});

			return this;
		},
		initCountdown: function() {

			this.ui.countdown.countdown();

			return this;
		}




	});

}(window, APP, Backbone, Marionette, $, _));